<template>
  <b-row>
    <b-col cols="10">
      <b-input-group size="sm">
        <b-form-input type="number" v-model="scale.maxPrice"/>
        <b-form-input type="number" v-model="scale.price"/>
      </b-input-group>
    </b-col>

    <b-col cols="1">
      <b-button variant="danger" size="sm" @click="deleteScale(index)">
        <feather-icon icon="MinusCircleIcon"/>
      </b-button>
    </b-col>

  </b-row>
</template>

<script>


export default {
  name: "ShippingScale",
  props: {
    index: {
      type: Number,
      required: true
    },
    storeId: {
      type: Number,
      required: true
    },
    scale: {
      type: Object,
      required: true
    },
    page: {
      type: String,
      default: ''
    }
  },
  methods: {
    deleteScale(index) {
      if(this.page === 'afn') {
        this.$store.commit('store/deleteAfnShippingScale', {storeId: this.storeId, indexNo: index})
        return
      }
      this.$store.commit('store/deleteShippingScale', {storeId: this.storeId, indexNo: index})
    }
  }
}
</script>

<style scoped>

</style>
